module.exports = __webpack_public_path__ + "img/rank1_2.7072bf8e.png";